export default function(name, mutation_name)
{
    return {
        get() { return this.$store.state[name] },
        set(val) { return this.$store.commit(mutation_name, val) }
    }
}